export default "__VITE_ASSET__UlCtTbgZ__"